import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const faqApi = createAsyncThunk("faq", async () => {
  const response = await axiosInstance.get(`/faq/getAll`);
  return response.data;
});

const faqSlice = createSlice({
  name: "faq",
  initialState: {
    faq: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(faqApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(faqApi.fulfilled, (state, action) => {
        state.faq = action.payload;
        state.loading = false;
      })
      .addCase(faqApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default faqSlice.reducer;
